"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPasswordResetApi = void 0;
exports.createPasswordResetApi = (axios) => ({
    acceptPasswordReset(props) {
        return __awaiter(this, void 0, void 0, function* () {
            yield axios.post('/passwordReset/accept', props);
        });
    },
    sendPasswordReset(email) {
        return __awaiter(this, void 0, void 0, function* () {
            yield axios.post('/passwordReset', { email });
        });
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFzc3dvcmRSZXNldEFwaS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hcGkvcGFzc3dvcmRSZXNldEFwaS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7QUFFYSxRQUFBLHNCQUFzQixHQUFHLENBQUMsS0FBb0IsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUN6RCxtQkFBbUIsQ0FBQyxLQUd6Qjs7WUFDQyxNQUFNLEtBQUssQ0FBQyxJQUFJLENBQUMsdUJBQXVCLEVBQUUsS0FBSyxDQUFDLENBQUM7UUFDbkQsQ0FBQztLQUFBO0lBRUssaUJBQWlCLENBQUMsS0FBYTs7WUFDbkMsTUFBTSxLQUFLLENBQUMsSUFBSSxDQUFDLGdCQUFnQixFQUFFLEVBQUUsS0FBSyxFQUFFLENBQUMsQ0FBQztRQUNoRCxDQUFDO0tBQUE7Q0FDRixDQUFDLENBQUMifQ==